import { on } from "svelte/events";
import type { Action } from "svelte/action";
import { onDestroy } from "../utils/props";

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const computeContentOverflow = (
  contentElement: HTMLElement | undefined | null,
  contentHeight: number,
): boolean => !!contentElement && contentElement.scrollHeight !== contentHeight;

export const computeScrollEnd = (contentElement: HTMLElement): boolean =>
  contentElement.offsetHeight + contentElement.scrollTop >= contentElement.scrollHeight - 1;

/**
 *
 *
 *
 *
 *
 *
 */
/*                                                                        */
export const useContentScroll = () => {
  const state = $state({
    /**
 *
 *
 *
 *
 */
    isScrollEnd: true,

    /**
 *
 *
 */
    isScrolling: false,

    /**
 *
 *
 */
    contentHeight: 0,

    /**
 *
 *
 */
    hasContentOverflow: false,

    /**
 *
 *
 */
    scrollPosition: ((contentElement) => {
      /**
 *
 *
 *
 */
      const computeScrollData = (): void => {
        state.isScrolling = contentElement.scrollTop > 0;
        state.isScrollEnd = computeScrollEnd(contentElement);
      };

      /*                                  */
      $effect(() => {
        state.hasContentOverflow = computeContentOverflow(contentElement, state.contentHeight);
        computeScrollData();
      });

      /*                         */
      return onDestroy(on(contentElement, "scroll", computeScrollData));
    }) as Action,
  });

  return state;
};
